declare namespace $ {

	type $mol_button_minor__hint_bog_merchquarium_counter_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_merchquarium_counter_2 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_counter['dec'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_merchquarium_counter_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_merchquarium_counter_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_merchquarium_counter_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_merchquarium_counter_6 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_counter['inc'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_merchquarium_counter_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_merchquarium_counter extends $mol_view {
		dec( next?: any ): any
		Minus_icon( ): $mol_icon_minus
		Minus( ): $mol_button_minor
		value_text( ): string
		Value( ): $mol_view
		inc( next?: any ): any
		Plus_icon( ): $mol_icon_plus
		Plus( ): $mol_button_minor
		content( ): readonly(any)[]
		value( next?: number ): number
		enabled( ): boolean
		sub( ): ReturnType< $bog_merchquarium_counter['content'] >
	}
	
}

//# sourceMappingURL=counter.view.tree.d.ts.map